import { useState } from 'react';
import { X, Loader2 } from 'lucide-react';
import api from '../../services/api';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, value, onChange, type = 'text', required }) => (
  <div>
    <label className="block text-xs font-bold text-gray-500 mb-1">{label}{required && ' *'}</label>
    <input
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 rounded-lg border-2 border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-orange-300"
    />
  </div>
);

/** Creates a brand-new project — the real Zoho Deal (+ Main Contractor package)
 * is created FIRST; it only appears on the dashboard once that CRM write succeeds. */
export const SpellersNewProjectModal = ({ onClose, onCreated }) => {
  const [form, setForm] = useState({ project_name: '', location: '', postcode: '', project_value: '', start_date: '', stage: '', project_status: '' });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.project_name.trim()) { toast.error('Project name is required'); return; }
    setSaving(true);
    try {
      const res = await api.post(`${API}/spellers/projects`, form);
      toast.success('Created — real Zoho Deal is live now');
      onCreated(res.data.project);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Failed to create in CRM');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 p-4" data-testid="spellers-new-project-modal">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-bold text-gray-900">New Project</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-testid="spellers-new-project-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-xs text-gray-500 mb-3">This creates a real Deal under Speller Metcalfe Malvern Limited in Zoho CRM immediately — it only shows on the dashboard once that succeeds.</p>
        <div className="space-y-3">
          <Field label="Project Name" required value={form.project_name} onChange={(v) => set('project_name', v)} />
          <div className="grid grid-cols-2 gap-3">
            <Field label="Location" value={form.location} onChange={(v) => set('location', v)} />
            <Field label="Postcode" value={form.postcode} onChange={(v) => set('postcode', v)} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Project Value" value={form.project_value} onChange={(v) => set('project_value', v)} />
            <Field label="Start Date" type="date" value={form.start_date} onChange={(v) => set('start_date', v)} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Stage" value={form.stage} onChange={(v) => set('stage', v)} />
            <Field label="Project Status" value={form.project_status} onChange={(v) => set('project_status', v)} />
          </div>
        </div>
        <button
          onClick={submit}
          disabled={saving}
          className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold text-white hover:opacity-90 disabled:opacity-60"
          style={{ backgroundColor: '#ee7203' }}
          data-testid="spellers-new-project-submit"
        >
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : null} {saving ? 'Creating in CRM…' : 'Create in CRM'}
        </button>
      </div>
    </div>
  );
};

export default SpellersNewProjectModal;
